import MemberCard from '@ingka/member-card';

import classnames from 'classnames';
import Text from '@ingka/text';
import { Trans } from 'react-i18next';

import { PREFIX } from '../../../Skapa/constants/constants';
import { LoyaltyCard } from '../menu-types';

import styles from './LoyaltyCard.module.scss';
import { t } from 'i18next';

interface CardInfoProps {
  loyaltyCard: LoyaltyCard;
}

// Wrapper component to filter out unwanted props from Trans
const ContactLink = ({ children, ...props }: any) => {
  // Filter out any non-standard HTML attributes that Trans might pass
  const { contactSupport: _nouse, ...validProps } = props;
  return (
    <a className={styles.contactUs} href="/contact-us/" target="_blank" rel="noreferrer" {...validProps}>
      {children}
    </a>
  );
};

export function CardInfo({ loyaltyCard }: Readonly<CardInfoProps>) {
  const inactive = loyaltyCard.memberStatus === 'error/loyalty-member-inactive';
  const qrCode = loyaltyCard.qrCodeDataUrl;
  return (
    <div className={classnames(styles.wrapper, styles.cardInfo)}>
      {qrCode || inactive ? (
        <MemberCard
          className={classnames(styles.loyaltyCard, {
            [styles.inactive]: inactive,
          })}
          prefix={PREFIX}
          title={loyaltyCard.title}
          number={loyaltyCard.cardIdentifier}
          name={loyaltyCard.name}
          variant="vertical"
          codeType="qrCode"
          program="ikea-family"
        >
          {qrCode && <img alt="IKEA Family Card barcode for scanning" src={qrCode} />}
        </MemberCard>
      ) : (
        <img
          src="https://asset.inter.ikea.com/images/PE777285_preview?v=27a843ec"
          style={{
            clipPath: 'circle(50%)',
            width: '240px',
            height: '240px',
          }}
          alt=""
        />
      )}

      {!qrCode && (
        <>
          <Text className={styles.errorTitle} prefix={PREFIX} tagName="h1" textStyle="Heading.L">
            {t('mainPage.loyaltyCard.family.buttonLabel')}
          </Text>
          <Text className={styles.helpText} prefix={PREFIX} tagName="div" textStyle="Body.M">
            <Trans
              i18nKey={inactive ? 'error.ikeaFamilyCard.inactive.body' : 'error.ikeaFamilyCard.generic.body'}
              ns="profile"
              components={[<ContactLink key="onlyone" />]}
            />
          </Text>
        </>
      )}
    </div>
  );
}
